// https://eu.posthog.com/project/281/feature_flags?tab=overview
export const FeatureFlags = {
  InitialInputLag: 'initial_input_lag',
  MobileModeAutoOptIn: 'mobile_mode_auto_opt_in',
  CalibrationBeforeFirstSong: 'calibration_before_first_song',
  LeaderboardBackfill: 'leaderboard_backfill',
} as const;
